import { useState } from 'react'
import { apiLogin, ui } from './shared'

export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await apiLogin(username, password)
      onLoggedIn()
    } catch (err) {
      setError(String(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--paper)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <form onSubmit={submit} style={{
        ...ui.card, width: '100%', maxWidth: 360,
      }}>
        <h1 style={ui.sectionTitle}>Accedi</h1>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <label>
            <span style={ui.label}>Username</span>
            <input style={ui.input} autoFocus value={username}
                   onChange={(e) => setUsername(e.target.value)} />
          </label>
          <label>
            <span style={ui.label}>Password</span>
            <input style={ui.input} type="password" value={password}
                   onChange={(e) => setPassword(e.target.value)} />
          </label>
          {error && (
            <div style={{ color: '#a33', fontSize: 13 }}>{error}</div>
          )}
          <button type="submit" style={{ ...ui.btn, marginTop: 8, opacity: busy ? 0.5 : 1 }} disabled={busy}>
            {busy ? '…' : 'Entra'}
          </button>
        </div>
      </form>
    </div>
  )
}
